/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
const n="updating";function t(n){return"updating"===n?null:n}function u(n){return"updating"===n}export{u as isUpdating,t as unwrapUpdating,n as updating};
